import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgbAccordionModule} from '@ng-bootstrap/ng-bootstrap';
import {CartSharedModule} from '@spartacus/cart/base/components';
import {AuthGuard, FeaturesConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {CardModule, CmsPageGuard, PageLayoutComponent, PromotionsModule} from '@spartacus/storefront';
import {AccordionModule, MessageModule} from 'ng-design-system';
import {AppComponent} from '../app.component';
import {ConfiguratorModule} from '../product/configurator/configurator.module';
import {
  ConfigureServiceErrorModule
} from '../product/configurator/error-handling/configure-service-error/configure-service-error.module';
import {
  ProductNameDisplayModule
} from '../product/details/navigation-bar/product-name-display/product-name-display.module';
import {DisposableMessageModule} from '../shared/disposable-message/disposable-message.module';
import {MetricTextModule} from '../shared/metric-text/metric-text.module';
import {SummaryModule} from '../shared/summary/summary.module';
import {BundleProvidedByModule} from './bundle-provided-by/bundle-provided-by.module';
import {CheckoutPaymentsModule} from './checkout-payments/checkout-payments.module';
import {CheckoutFooterModule} from './checkout-footer/checkout-footer.module';
import {CheckoutLicensesModule} from './checkout-licenses/checkout-licenses.module';
import {PurchaseOrderNumberModule} from './checkout-purchase-order-number/purchase-order-number.module';
import {CheckoutSupportWidgetModule} from './checkout-support-widget/checkout-support-widget.module';
import {TermsAndConditionsModule} from './checkout-terms-conditions/terms-and-conditions.module';
import {DcpCheckoutOrderSummaryModule} from './dcp-checkout-order-summary/dcp-checkout-order-summary.module';
import {DcpCheckoutPlaceOrderModule} from './dcp-checkout-place-order/dcp-checkout-place-order.module';
import {DcpReviewSubmitModule} from './dcp-review-submit/dcp-review-submit.module';
import {
  InvalidCartEntryMessageModule
} from './error-handling/invalid-cart-entry-message/invalid-cart-entry-message.module';
import {DynamicAuthGuard} from './guards/dynamic-auth.guard';
import {DynamicCheckoutStepSelectionGuard} from './guards/dynamic-checkout-step-selection.guard';
import {UserAccountFacadeUpdateGuard} from './guards/user-account-facade-update.guard';
import {DcpOrderConfirmationModule} from './order-confirmation/order-confirmation.module';
import {OrderTableModule} from './order-table/order-table.module';
import {ProvidedByModule} from './provided-by/provided-by.module';
import {
  RemoveProductSuccessMessageModule
} from './remove-product-success-message/remove-product-success-message.module';
import {AuthGuardWithRedirection} from './guards/auth-guard-with-redirection.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CardModule,
    I18nModule,
    UrlModule,
    FeaturesConfigModule,
    PromotionsModule,
    CartSharedModule,
    AccordionModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {pageLabel: 'order', cxRoute: 'orderGuest'},
      },
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {cxRoute: 'orderDetails'},
      },
      {
        path: 'checkout',
        component: AppComponent,
        canActivate: [DynamicCheckoutStepSelectionGuard, UserAccountFacadeUpdateGuard],
      },
      {
        path: 'checkout/review-order',
        component: PageLayoutComponent,
        data: {pageLabel: '/checkout/review-order'},
        canActivate: [CmsPageGuard, DynamicAuthGuard],
      },
      {
        path: 'order-confirmation',
        component: PageLayoutComponent,
        data: {
          pageLabel: '/order-confirmation',
          redirectUrl: '/',
        },
        canActivate: [CmsPageGuard, AuthGuardWithRedirection],
      },
    ]),
    SummaryModule,
    DcpOrderConfirmationModule,
    DcpCheckoutOrderSummaryModule,
    DcpCheckoutPlaceOrderModule,
    ConfiguratorModule,
    CheckoutLicensesModule,
    CheckoutPaymentsModule,
    TermsAndConditionsModule,
    PurchaseOrderNumberModule,
    NgbAccordionModule,
    MessageModule,
    ProductNameDisplayModule,
    ProvidedByModule,
    DisposableMessageModule,
    MetricTextModule,
    InvalidCartEntryMessageModule,
    ConfigureServiceErrorModule,
    BundleProvidedByModule,
    OrderTableModule,
    RemoveProductSuccessMessageModule,
    DcpOrderConfirmationModule,
    CheckoutFooterModule,
    CheckoutSupportWidgetModule,
    DcpReviewSubmitModule,
  ],
  exports: [],
})
export class DcpCheckoutModule {
}
